// src/components/QuetionModal.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { TreeSelect, Select, Button, Form, Modal, Input, Row, Col, Upload, AudioFilled, Radio, Textarea, InputNumber, UploadImg, DatePicker, Checkbox, Switch } from '../../ui/ot';
import { useTranslation } from 'react-i18next';
import { createContext } from 'react';
import { useContext } from 'react';
import { useRef } from 'react';
import { useCirculationRules } from "../controllers/CirculationRulesController";


const LanguageContext = createContext(null)

const CirculationRulesModal = ({
    keyPrefix = "library.backstage.Circulation.Rules",
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => {

    },
    onFinish = () => {

    },
    reloadTable = () => { },
    modalStyle = {},
    openButtonStyle = {
        backgroundColor: "#fff8c8",
        color: "#000"
    },
    customFormItems = () => { },
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const axiosModelanguage = {
        post: t('post'),
        patch: t('edit')
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])


    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }

            <Modal
                style={{ top: 10, }}
                contentStyle={{ padding: 16 }}
                // width={1000}
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                okText={t('ok')}
                cancelText={t('cancel')}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
            >
                <Row
                >
                    <Col span={24}>
                        <CirculationRulesP1Form
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                            customFormItems={customFormItems}                            
                        />
                    </Col>
                </Row>
            </Modal>
        </LanguageContext.Provider>
    </>);
};
export default CirculationRulesModal;



const CirculationRulesP1Form = ({
    keyPrefix = "library.backstage.Circulation.Rules",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    initialValues,
    hasValue = false,
    customFormItems = () => {},
    // defaultValue = {},
    field, 
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [form] = Form.useForm();
    const [p1_data, set_p1_data] = useState([])
    const [branch_data, set_branch_data] = useState([])

    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
        // propsOnValuesChange({
        //     ...formValues,
        //     // ...e
        // })
    }
    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };


    const {
        CirculationRulesTypeData, 
        getCirculationRulesTypeData, 
    } = useCirculationRules({
        onBefore: () => { },
        onFinish: () => { },
    })

    useEffect(() => {
        setDataInitialization();
        getCirculationRulesTypeData()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    // useEffect(() => {
    //     (propsForm ?? form).setFieldsValue({ ...defaultValue })
    // }, [defaultValue])
    useEffect(() => {
        let p1 = CirculationRulesTypeData.filter(item => item.p === "P1").find(_ => true)?.rules
        let branch = CirculationRulesTypeData.filter(item => item.p === "P0").find(_ => true)?.rules
        set_p1_data(p1)
        set_branch_data(branch)
    }, [CirculationRulesTypeData])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <P1FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                                p1_data={p1_data}
                                branch_data={branch_data}
                                // options={options}
                            />
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
const P1FormItemComponent = ({ 
    keyPrefix, 
    field, 
    initialValues = {}, 
    options, 
    hasValue = false,
    p1_data, 
    branch_data, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('select_a_library')}`}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode']}
                            initialValue={initialValues?.branchcode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(branch_data) && branch_data.length > 0 ? branch_data.filter(item => item.rule_name === "branchcode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('patron_category')}`}
                            name={[field?.name ?? '', 'categorycode']}
                            fieldKey={[field?.fieldKey ?? '', 'categorycode']}
                            initialValue={initialValues?.categorycode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "categorycode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('item_type')}`}
                            name={[field?.name ?? '', 'itemtype']}
                            fieldKey={[field?.fieldKey ?? '', 'itemtype']}
                            initialValue={initialValues?.itemtype}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "itemtype").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('note')}`}
                            name={[field?.name ?? '', 'note']}
                            fieldKey={[field?.fieldKey ?? '', 'note']}
                            initialValue={initialValues?.note}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input />
                        </Form.Item>
                    </Col> */}

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('current_checkouts_allowed')}`}
                            name={[field?.name ?? '', 'maxissueqty']}
                            fieldKey={[field?.fieldKey ?? '', 'maxissueqty']}
                            initialValue={initialValues?.maxissueqty}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('current_on_site_checkouts_allowed')}`}
                            name={[field?.name ?? '', 'maxonsiteissueqty']}
                            fieldKey={[field?.fieldKey ?? '', 'maxonsiteissueqty']}
                            initialValue={initialValues?.maxonsiteissueqty}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('loan_period')}`}
                            name={[field?.name ?? '', 'issuelength']}
                            fieldKey={[field?.fieldKey ?? '', 'issuelength']}
                            initialValue={initialValues?.issuelength}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('days_mode')}`}
                            name={[field?.name ?? '', 'daysmode']}
                            fieldKey={[field?.fieldKey ?? '', 'daysmode']}
                            initialValue={initialValues?.daysmode}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "daysmode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('unit')}`}
                            name={[field?.name ?? '', 'lengthunit']}
                            fieldKey={[field?.fieldKey ?? '', 'lengthunit']}
                            initialValue={initialValues?.lengthunit}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "lengthunit").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('hard_due_date_compare')}`}
                            name={[field?.name ?? '', 'hardduedatecompare']}
                            fieldKey={[field?.fieldKey ?? '', 'hardduedatecompare']}
                            initialValue={initialValues?.hardduedatecompare}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "hardduedatecompare").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('hard_due_date')}`}
                            name={[field?.name ?? '', 'hardduedate']}
                            fieldKey={[field?.fieldKey ?? '', 'hardduedate']}
                            initialValue={initialValues?.hardduedate}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input type="date" />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('decreased_loan_period_for_high_holds')}`}
                            name={[field?.name ?? '', 'decreaseloanholds']}
                            fieldKey={[field?.fieldKey ?? '', 'decreaseloanholds']}
                            initialValue={initialValues?.decreaseloanholds}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('fine_amount')}`}
                            name={[field?.name ?? '', 'fine']}
                            fieldKey={[field?.fieldKey ?? '', 'fine']}
                            initialValue={initialValues?.fine}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('fine_charging_interval')}`}
                            name={[field?.name ?? '', 'chargeperiod']}
                            fieldKey={[field?.fieldKey ?? '', 'chargeperiod']}
                            initialValue={initialValues?.chargeperiod}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('when_to_charge')}`}
                            name={[field?.name ?? '', 'chargeperiod_charge_at']}
                            fieldKey={[field?.fieldKey ?? '', 'chargeperiod_charge_at']}
                            initialValue={initialValues?.chargeperiod_charge_at}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "chargeperiod_charge_at").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('fine_suspension_grace_period')}`}
                            name={[field?.name ?? '', 'firstremind']}
                            fieldKey={[field?.fieldKey ?? '', 'firstremind']}
                            initialValue={initialValues?.firstremind}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('overdue_fines_cap')}`}
                            name={[field?.name ?? '', 'overduefinescap']}
                            fieldKey={[field?.fieldKey ?? '', 'overduefinescap']}
                            initialValue={initialValues?.overduefinescap}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('cap_fine_at_replacement_price')}`}
                            name={[field?.name ?? '', 'cap_fine_to_replacement_price']}
                            fieldKey={[field?.fieldKey ?? '', 'cap_fine_to_replacement_price']}
                            initialValue={initialValues?.cap_fine_to_replacement_price}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Switch />
                        </Form.Item>
                    </Col> */}

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('suspension_in_days')}`}
                            name={[field?.name ?? '', 'finedays']}
                            fieldKey={[field?.fieldKey ?? '', 'finedays']}
                            initialValue={initialValues?.finedays}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('max_suspension_duration')}`}
                            name={[field?.name ?? '', 'maxsuspensiondays']}
                            fieldKey={[field?.fieldKey ?? '', 'maxsuspensiondays']}
                            initialValue={initialValues?.maxsuspensiondays}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('suspension_charging_interval')}`}
                            name={[field?.name ?? '', 'suspension_chargeperiod']}
                            fieldKey={[field?.fieldKey ?? '', 'suspension_chargeperiod']}
                            initialValue={initialValues?.suspension_chargeperiod}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('renewals_allowed')}`}
                            name={[field?.name ?? '', 'renewalsallowed']}
                            fieldKey={[field?.fieldKey ?? '', 'renewalsallowed']}
                            initialValue={initialValues?.renewalsallowed}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('renewal_period')}`}
                            name={[field?.name ?? '', 'renewalperiod']}
                            fieldKey={[field?.fieldKey ?? '', 'renewalperiod']}
                            initialValue={initialValues?.renewalperiod}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('no_renewal_before')}`}
                            name={[field?.name ?? '', 'norenewalbefore']}
                            fieldKey={[field?.fieldKey ?? '', 'norenewalbefore']}
                            initialValue={initialValues?.norenewalbefore}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('no_automatic_renewal_before')}`}
                            name={[field?.name ?? '', 'noautorenewalbefore']}
                            fieldKey={[field?.fieldKey ?? '', 'noautorenewalbefore']}
                            initialValue={initialValues?.noautorenewalbefore}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('automatic_renewal')}`}
                            name={[field?.name ?? '', 'auto_renew']}
                            fieldKey={[field?.fieldKey ?? '', 'auto_renew']}
                            initialValue={initialValues?.auto_renew}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "auto_renew").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>

                    {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('no_automatic_renewal_after')}`}
                            name={[field?.name ?? '', 'no_auto_renewal_after']}
                            fieldKey={[field?.fieldKey ?? '', 'no_auto_renewal_after']}
                            initialValue={initialValues?.no_auto_renewal_after}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col> */}

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('no_automatic_renewal_after_hard_limit')}`}
                            name={[field?.name ?? '', 'no_auto_renewal_after_hard_limit']}
                            fieldKey={[field?.fieldKey ?? '', 'no_auto_renewal_after_hard_limit']}
                            initialValue={initialValues?.no_auto_renewal_after_hard_limit}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input  type="date" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('holds_allowed_total')}`}
                            name={[field?.name ?? '', 'reservesallowed']}
                            fieldKey={[field?.fieldKey ?? '', 'reservesallowed']}
                            initialValue={initialValues?.reservesallowed}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('holds_allowed_daily')}`}
                            name={[field?.name ?? '', 'holds_per_day']}
                            fieldKey={[field?.fieldKey ?? '', 'holds_per_day']}
                            initialValue={initialValues?.holds_per_day}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('holds_per_record')}`}
                            name={[field?.name ?? '', 'holds_per_record']}
                            fieldKey={[field?.fieldKey ?? '', 'holds_per_record']}
                            initialValue={initialValues?.holds_per_record}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('onself_holds_allowed')}`}
                            name={[field?.name ?? '', 'onshelfholds']}
                            fieldKey={[field?.fieldKey ?? '', 'onshelfholds']}
                            initialValue={initialValues?.onshelfholds}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "onshelfholds").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('opac_item_level_holds')}`}
                            name={[field?.name ?? '', 'opacitemholds']}
                            fieldKey={[field?.fieldKey ?? '', 'opacitemholds']}
                            initialValue={initialValues?.opacitemholds}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p1_data) && p1_data.length > 0 ? p1_data.filter(item => item.rule_name === "opacitemholds").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('holds_pick_up_period')}`}
                            name={[field?.name ?? '', 'holds_pickup_period']}
                            fieldKey={[field?.fieldKey ?? '', 'holds_pickup_period']}
                            initialValue={initialValues?.holds_pickup_period}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('rental_discount')}`}
                            name={[field?.name ?? '', 'rentaldiscount']}
                            fieldKey={[field?.fieldKey ?? '', 'rentaldiscount']}
                            initialValue={initialValues?.rentaldiscount}
                            rules={!hasValue ? [
                                {
                                    // required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <InputNumber min={0} />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
const CirculationRulesP2Form = ({
    keyPrefix = "library.backstage.Circulation.Rules",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    initialValues,
    hasValue = false,
    customFormItems = () => {},
    defaultValue = {},
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [form] = Form.useForm();
    const [p2_data, set_p2_data] = useState([])
    const [branch_data, set_branch_data] = useState([])

    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
        propsOnValuesChange({
            ...formValues,
            // ...e
        })
    }
    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };


    const {
        CirculationRulesTypeData, 
        getCirculationRulesTypeData, 
    } = useCirculationRules({
        onBefore: () => { },
        onFinish: () => { },
    })

    useEffect(() => {
        setDataInitialization();
        getCirculationRulesTypeData()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    useEffect(() => {
        let p2 = CirculationRulesTypeData.filter(item => item.p === "P2").find(_ => true)?.rules
        let branch = CirculationRulesTypeData.filter(item => item.p === "P0").find(_ => true)?.rules
        set_p2_data(p2)
        set_branch_data(branch)
    }, [CirculationRulesTypeData])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <P2FormItemComponent
                                keyPrefix={keyPrefix}
                                field={fieldName}
                                initialValues={initialValues}
                                p2_data={p2_data}
                                branch_data={branch_data}
                                // options={options}
                            />
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
const P2FormItemComponent = ({ 
    keyPrefix, 
    field, 
    initialValues = {}, 
    options, 
    hasValue = false,
    p2_data, 
    branch_data, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('select_a_library')}`}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode']}
                            initialValue={initialValues?.branchcode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(branch_data) && branch_data.length > 0 ? branch_data.filter(item => item.rule_name === "branchcode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('total_current_checkouts_allowed')}`}
                            name={[field?.name ?? '', 'patron_maxissueqty']}
                            fieldKey={[field?.fieldKey ?? '', 'patron_maxissueqty']}
                            initialValue={initialValues?.patron_maxissueqty}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('total_current_on_site_checkouts_allowed')}`}
                            name={[field?.name ?? '', 'patron_maxonsiteissueqty']}
                            fieldKey={[field?.fieldKey ?? '', 'patron_maxonsiteissueqty']}
                            initialValue={initialValues?.patron_maxonsiteissueqty}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('maximum_total_holds_allowed_count')}`}
                            name={[field?.name ?? '', 'max_holds']}
                            fieldKey={[field?.fieldKey ?? '', 'max_holds']}
                            initialValue={initialValues?.max_holds}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('hold_policy')}`}
                            name={[field?.name ?? '', 'holdallowed']}
                            fieldKey={[field?.fieldKey ?? '', 'holdallowed']}
                            initialValue={initialValues?.holdallowed}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p2_data) && p2_data.length > 0 ? p2_data.filter(item => item.rule_name === "holdallowed").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('hold_pickup_library_match')}`}
                            name={[field?.name ?? '', 'hold_fulfillment_policy']}
                            fieldKey={[field?.fieldKey ?? '', 'hold_fulfillment_policy']}
                            initialValue={initialValues?.hold_fulfillment_policy}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p2_data) && p2_data.length > 0 ? p2_data.filter(item => item.rule_name === "hold_fulfillment_policy").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('return_policy')}`}
                            name={[field?.name ?? '', 'returnbranch']}
                            fieldKey={[field?.fieldKey ?? '', 'returnbranch']}
                            initialValue={initialValues?.returnbranch}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p2_data) && p2_data.length > 0 ? p2_data.filter(item => item.rule_name === "returnbranch").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
const CirculationRulesP3Form = ({
    keyPrefix = "library.backstage.Circulation.Rules",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    initialValues,
    hasValue = false,
    customFormItems = () => {},
    defaultValue = {},
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [form] = Form.useForm();
    const [p3_data, set_p3_data] = useState([])
    const [branch_data, set_branch_data] = useState([])

    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
        propsOnValuesChange({
            ...formValues,
            // ...e
        })
    }
    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };

    
    const {
        CirculationRulesTypeData, 
        getCirculationRulesTypeData, 
    } = useCirculationRules({
        onBefore: () => { },
        onFinish: () => { },
    })

    useEffect(() => {
        setDataInitialization();
        getCirculationRulesTypeData()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    useEffect(() => {
        let p3 = CirculationRulesTypeData.filter(item => item.p === "P3").find(_ => true)?.rules
        let branch = CirculationRulesTypeData.filter(item => item.p === "P0").find(_ => true)?.rules
        set_p3_data(p3)
        set_branch_data(branch)
    }, [CirculationRulesTypeData])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <P3FormItemComponent
                                keyPrefix={keyPrefix}
                                field={fieldName}
                                initialValues={initialValues}
                                p3_data={p3_data}
                                branch_data={branch_data}
                                // options={options}
                            />
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
const P3FormItemComponent = ({ 
    keyPrefix, 
    field, 
    initialValues = {}, 
    options, 
    hasValue = false,
    p3_data, 
    branch_data, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('select_a_library')}`}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode']}
                            initialValue={initialValues?.branchcode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(branch_data) && branch_data.length > 0 ? branch_data.filter(item => item.rule_name === "branchcode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('patron_category')}`}
                            name={[field?.name ?? '', 'categorycode']}
                            fieldKey={[field?.fieldKey ?? '', 'categorycode']}
                            initialValue={initialValues?.categorycode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p3_data) && p3_data.length > 0 ? p3_data.filter(item => item.rule_name === "categorycode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('total_current_checkouts_allowed')}`}
                            name={[field?.name ?? '', 'patron_maxissueqty']}
                            fieldKey={[field?.fieldKey ?? '', 'patron_maxissueqty']}
                            initialValue={initialValues?.patron_maxissueqty}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('total_current_on_site_checkouts_allowed')}`}
                            name={[field?.name ?? '', 'patron_maxonsiteissueqty']}
                            fieldKey={[field?.fieldKey ?? '', 'patron_maxonsiteissueqty']}
                            initialValue={initialValues?.patron_maxonsiteissueqty}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('total_holds_allowed')}`}
                            name={[field?.name ?? '', 'max_holds']}
                            fieldKey={[field?.fieldKey ?? '', 'max_holds']}
                            initialValue={initialValues?.max_holds}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
const CirculationRulesP4Form = ({
    keyPrefix = "library.backstage.Circulation.Rules",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    initialValues,
    hasValue = false,
    customFormItems = () => {},
    defaultValue = {},
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [form] = Form.useForm();
    const [p4_data, set_p4_data] = useState([])
    const [branch_data, set_branch_data] = useState([])

    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
        propsOnValuesChange({
            ...formValues,
            // ...e
        })
    }
    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };

    
    const {
        CirculationRulesTypeData, 
        getCirculationRulesTypeData, 
    } = useCirculationRules({
        onBefore: () => { },
        onFinish: () => { },
    })

    useEffect(() => {
        setDataInitialization();
        getCirculationRulesTypeData()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    useEffect(() => {
        let p4 = CirculationRulesTypeData.filter(item => item.p === "P4").find(_ => true)?.rules
        let branch = CirculationRulesTypeData.filter(item => item.p === "P0").find(_ => true)?.rules
        set_p4_data(p4)
        set_branch_data(branch)
    }, [CirculationRulesTypeData])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <P4FormItemComponent
                                keyPrefix={keyPrefix}
                                field={fieldName}
                                initialValues={initialValues}
                                p4_data={p4_data}
                                branch_data={branch_data}
                                // options={options}
                            />
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
const P4FormItemComponent = ({ 
    keyPrefix, 
    field, 
    initialValues = {}, 
    options, 
    hasValue = false,
    p4_data, 
    branch_data, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('select_a_library')}`}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode']}
                            initialValue={initialValues?.branchcode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(branch_data) && branch_data.length > 0 ? branch_data.filter(item => item.rule_name === "branchcode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('patron_category')}`}
                            name={[field?.name ?? '', 'categorycode']}
                            fieldKey={[field?.fieldKey ?? '', 'categorycode']}
                            initialValue={initialValues?.categorycode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p4_data) && p4_data.length > 0 ? p4_data.filter(item => item.rule_name === "categorycode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('item_type')}`}
                            name={[field?.name ?? '', 'itemtype']}
                            fieldKey={[field?.fieldKey ?? '', 'itemtype']}
                            initialValue={initialValues?.itemtype}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p4_data) && p4_data.length > 0 ? p4_data.filter(item => item.rule_name === "itemtype").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('cancellation_allowed')}`}
                            name={[field?.name ?? '', 'waiting_hold_cancellation']}
                            fieldKey={[field?.fieldKey ?? '', 'waiting_hold_cancellation']}
                            initialValue={initialValues?.waiting_hold_cancellation}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p4_data) && p4_data.length > 0 ? p4_data.filter(item => item.rule_name === "waiting_hold_cancellation").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
const CirculationRulesP5Form = ({
    keyPrefix = "library.backstage.Circulation.Rules",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    initialValues,
    hasValue = false,
    customFormItems = () => {},
    defaultValue = {},
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [form] = Form.useForm();
    const [p5_data, set_p5_data] = useState([])
    const [branch_data, set_branch_data] = useState([])

    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
        propsOnValuesChange({
            ...formValues,
            // ...e
        })
    }

    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };


    const {
        CirculationRulesTypeData, 
        getCirculationRulesTypeData, 
    } = useCirculationRules({
        onBefore: () => { },
        onFinish: () => { },
    })

    useEffect(() => {
        setDataInitialization();
        getCirculationRulesTypeData()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    useEffect(() => {
        let p5 = CirculationRulesTypeData.filter(item => item.p === "P5").find(_ => true)?.rules
        let branch = CirculationRulesTypeData.filter(item => item.p === "P0").find(_ => true)?.rules
        set_p5_data(p5)
        set_branch_data(branch)
    }, [CirculationRulesTypeData])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <P5FormItemComponent
                                keyPrefix={keyPrefix}
                                field={fieldName}
                                initialValues={initialValues}
                                p5_data={p5_data}
                                branch_data={branch_data}
                                // options={options}
                            />
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
const P5FormItemComponent = ({ 
    keyPrefix, 
    field, 
    initialValues = {}, 
    options, 
    hasValue = false,
    p5_data, 
    branch_data, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('select_a_library')}`}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode']}
                            initialValue={initialValues?.branchcode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(branch_data) && branch_data.length > 0 ? branch_data.filter(item => item.rule_name === "branchcode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('refund_lost_item_replacement_fee')}`}
                            name={[field?.name ?? '', 'lostreturn']}
                            fieldKey={[field?.fieldKey ?? '', 'lostreturn']}
                            initialValue={initialValues?.lostreturn}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p5_data) && p5_data.length > 0 ? p5_data.filter(item => item.rule_name === "lostreturn").find(_ => true)?.options.filter(item => item.value !== "*").map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('refund_lost_item_processing_fee')}`}
                            name={[field?.name ?? '', 'processingreturn']}
                            fieldKey={[field?.fieldKey ?? '', 'processingreturn']}
                            initialValue={initialValues?.processingreturn}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p5_data) && p5_data.length > 0 ? p5_data.filter(item => item.rule_name === "processingreturn").find(_ => true)?.options.filter(item => item.value !== "*").map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
const CirculationRulesP6Form = ({
    keyPrefix = "library.backstage.Circulation.Rules",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    initialValues,
    hasValue = false,
    customFormItems = () => {},
    defaultValue = {},
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [form] = Form.useForm();
    const [p6_data, set_p6_data] = useState([])
    const [branch_data, set_branch_data] = useState([])

    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
        propsOnValuesChange({
            ...formValues,
            // ...e
        })
    }

    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };


    const {
        CirculationRulesTypeData, 
        getCirculationRulesTypeData, 
    } = useCirculationRules({
        onBefore: () => { },
        onFinish: () => { },
    })

    useEffect(() => {
        setDataInitialization();
        getCirculationRulesTypeData()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    useEffect(() => {
        let p6 = CirculationRulesTypeData.filter(item => item.p === "P6").find(_ => true)?.rules
        let branch = CirculationRulesTypeData.filter(item => item.p === "P0").find(_ => true)?.rules
        set_p6_data(p6)
        set_branch_data(branch)
    }, [CirculationRulesTypeData])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <P6FormItemComponent
                                keyPrefix={keyPrefix}
                                field={fieldName}
                                initialValues={initialValues}
                                p6_data={p6_data}
                                branch_data={branch_data}
                                // options={options}
                            />
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
const P6FormItemComponent = ({ 
    keyPrefix, 
    field, 
    initialValues = {}, 
    options, 
    hasValue = false,
    p6_data, 
    branch_data, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
        
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('select_a_library')}`}
                            name={[field?.name ?? '', 'branchcode']}
                            fieldKey={[field?.fieldKey ?? '', 'branchcode']}
                            initialValue={initialValues?.branchcode}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(branch_data) && branch_data.length > 0 ? branch_data.filter(item => item.rule_name === "branchcode").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('item_type')}`}
                            name={[field?.name ?? '', 'itemtype']}
                            fieldKey={[field?.fieldKey ?? '', 'itemtype']}
                            initialValue={initialValues?.itemtype}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p6_data) && p6_data.length > 0 ? p6_data.filter(item => item.rule_name === "itemtype").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.rule_name,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('hold_policy')}`}
                            name={[field?.name ?? '', 'holdallowed']}
                            fieldKey={[field?.fieldKey ?? '', 'holdallowed']}
                            initialValue={initialValues?.holdallowed}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p6_data) && p6_data.length > 0 ? p6_data.filter(item => item.rule_name === "holdallowed").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('hold_pickup_library_match')}`}
                            name={[field?.name ?? '', 'hold_fulfillment_policy']}
                            fieldKey={[field?.fieldKey ?? '', 'hold_fulfillment_policy']}
                            initialValue={initialValues?.hold_fulfillment_policy}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p6_data) && p6_data.length > 0 ? p6_data.filter(item => item.rule_name === "hold_fulfillment_policy").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={`${t('return_policy')}`}
                            name={[field?.name ?? '', 'returnbranch']}
                            fieldKey={[field?.fieldKey ?? '', 'returnbranch']}
                            initialValue={initialValues?.returnbranch}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Select
                                style={{
                                    maxWidth: "20vw",
                                    minWidth: "10vw",
                                    overflowX: "scroll",
                                    overflowY: "scroll",
                                }}
                                options={Array.isArray(p6_data) && p6_data.length > 0 ? p6_data.filter(item => item.rule_name === "returnbranch").find(_ => true)?.options.map(item => (
                                    {
                                        label: item?.text,
                                        value: item?.value,
                                    }
                                )) : []}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export { CirculationRulesP1Form, CirculationRulesP2Form, CirculationRulesP3Form, CirculationRulesP4Form, CirculationRulesP5Form, CirculationRulesP6Form }